export const MESSAGES = {
  confirmLogout:  'Are you sure you want to logout?',
  confirmCreate:  'Are you sure you want to create this {item}?',
  confirmImport:  'Are you sure you want to import this {item}?',
  confirmUpdate:  'Are you sure you want to edit this {item}?',
  confirmDelete:  'Are you sure you want to delete this {item}?',
  confirmDisable:  'Are you sure you want to disable this {item}?',
  confirmEnable:  'Are you sure you want to enable this {item}?',
  confirmDeleteWithName: 'Are you sure you want delete this {module}: {item}?',
  confirmResendVerification:  'Are you sure you want to resend account activation email to this user?',
  pageNotFoundTitle: 'Sorry, the page you visited does not exist.',
  successCreate: '{item} has been successfully created.',
  successUpdate: '{item} has been successfully updated.',
  successDisable: '{item} has been successfully disabled.',
  successEnable: '{item} has been successfully enabled.',
  successDelete: '{item} has been successfully deleted.',
  successImport: '{item} successfully imported.',
  successResendVerification: 'Account activation email has been successfully sent.',
  unauthorizedAppAccessTitle: 'You are not authorized to access this app.',
  unauthorizedDisabledCustomerTitle: 'Your account is disabled and not authorized to access this app.',
  invalidFile: 'The file type you uploaded is invalid. Please upload a .png/.jpg/.svg file.',
  invalidProfileImageFile: 'The file type you uploaded is invalid. Please upload a .png/.jpg file.',
  invalidFileSize: 'The file exceeds the maximum size of 5 MB. Please upload a file within the limit.',
  invalidBrandLogoSize: 'The file exceeds the maximum size of 1 MB. Please upload a file within the limit.',
  invalidDesktopLogoFile: 'The file type you uploaded is invalid. The desktop logo needs a transparent background, so please upload a .svg or .png file.',
  invalidDesktopLogoTooTall: 'Your image is {item}, which is too tall for the sidebar. The desktop logo needs to be a wide, banner-shaped image — 1200 x 256 px works best. Please resize it and try again.',
  invalidDesktopLogoTooWide: 'Your image is {item}, which is too long and thin for the sidebar. The desktop logo works best at 1200 x 256 px. Please resize it and try again.',
  invalidDesktopLogoWidth: 'Your image is {item}, which is too small and will look blurry in the sidebar. Please upload a larger version — 1200 x 256 px works best.',
  invalidMobileLogoFile: 'The file type you uploaded is invalid. The mobile logo needs a transparent background, so please upload a .svg or .png file.',
  invalidMobileLogoTooTall: 'Your image is {item}, which is too tall for the mobile logo. It needs to be a square icon — 128 x 128 px works best. Please resize it and try again.',
  invalidMobileLogoTooWide: 'Your image is {item}, which is too wide for the mobile logo. It needs to be a square icon, not a full logo — 128 x 128 px works best. Please resize it and try again.',
  invalidMobileLogoWidth: 'Your image is {item}, which is too small and will look blurry. Please upload a larger version — 128 x 128 px works best.',
  viewSingleItemTip: 'To continue, click on any item from the list on the left for more details.',
  noInspections: 'No inspection types found.',
  noIssues: 'No issues found for this asset.',
  noThreadMessages: 'No messages yet.',
  errorLoadComments: 'The messages could not be loaded. Please try again.',
  errorSendComment: 'Your message was not sent. Please try again.',
  errorEditComment: 'Your changes were not saved. Please try again.',
  errorDeleteComment: 'The message was not deleted. Please try again.',
  errorSaveTheme: 'The theme could not be saved. Please try again.',
  confirmDeleteComment: 'Delete this message? This cannot be undone.',
  invalidImageAttachment: 'That is not an image. Please choose a .png or .jpg file.',
  invalidAudioAttachment: 'That is not a voice recording. Please choose a .mp3, .m4a, .wav or .ogg file.',
  microphoneUnavailable: 'Your microphone could not be used. Allow microphone access for this site in your browser, then try again.',
  recordingFailed: 'The recording could not be saved. Please try again.',
  noComponents: 'No components found for this asset.',
  noUsers: 'No users found.',
  noCustomerAccounts: 'No customer accounts found.',
  noCustomerAdminAccounts: 'No customer admin accounts found.',
  noOpenIssues: 'No open issues found for this asset.',
  saveChanges: 'Are you sure you want to make these changes?',
  // Assets
  noAssets: 'No assets found.',
  noAssetTypes: 'No assets types found.',
  csvFileOnly: 'Only .csv files are allowed, please try again.',
  assetNoLongerExists: 'Asset no longer exists.',
  // Issues
  noIssuesFound: 'No issues found',
  confirmAssignToMaintenance: 'Are you sure you want to assign this issue to maintenance?',
  successAssignToMaintenance: 'Issue has been assigned to maintenance.',
  confirmSetSeverity: 'Are you sure you want set this severity status to {item}?',
  successSetSeverity: 'Severity status successfully set to {item}.',
  confirmSetForInspectorValidation: 'Are you sure you want to set this issue as ready for inspector validation?',
  successSetForInspectorValidation: 'Issue has been set as ready for validation.',
  confirmMarkAsNoFault: 'Are you sure you want to mark this issue as No Fault?',
  successMarkAsNoFault: 'Issue has been set as No Fault',
  // Components
  noComponentsFound: 'No components found',
  confirmDeleteComponent: 'Are you sure you want delete this component: {item}?',
  successDeleteComponent: 'Component has been successfully deleted.',
  successCreateComponent: 'Component has been successfully created.',
  successEditComponent: 'Component has been successfully edited.',
  selectTypes: 'Select one or more types...',
  noSymptoms: 'No symptoms listed for this component.',
  // Checklist
  noWorkingComponents: 'No working components.',
  noChecklist: 'No checklist history.',
  // Notifications
  noNotifications: 'No notifications.',
  notificationsDeleted: 'Notifications have been successfully deleted.',
  confirmBulkDeleteNotifications: 'Are you sure you want to delete the selected notifications?',
  confirmDeleteAllNotifications: 'Are you sure you want to delete all the notifications?',
  // Users
  importPreview: 'You are about to perform the following operations. Do you want to proceed?',
  noLicenses: 'No licenses.',
  // Dashboard
  dashboardNoAssets: 'There are no available asset locations.<br>Please make sure that the Telematics devices are installed and configured properly.',
  createTempUser: 'Are you sure you want to create a temporary admin user for {item}? This user will expire in 24 hours.'
};

export const FIELD_ERROR = {
  required: 'This field is required.',
  minLength: 'This field is required.',
  alphaNumeric: 'Only alphanumeric characters are allowed.',
  alphaNumericSpace: 'Only alphanumeric characters and space are allowed.',
  alphaNumericSpaceDash: 'Only alphanumeric characters, dash, and space are allowed.',
  alphaNumericDash: 'Only alphanumeric characters and dash are allowed.',
  minComponent: 'Atleast one component is required.',
  unique: 'This is already an existing symptom.',
  notEmpty: 'This field is required.',
  email: 'Invalid email address.',
  maxLength: 'Maximum of {{1}} characters are allowed.',
  nonUniqueAreaName: 'Area names should be unique for each inspection type.',
  numeric: 'Only numbers are allowed.',
  minEndDateLicense: 'End date must be atleast one month after the start date.',
  numericWithPlus: 'Only the plus sign and numeric characters are allowed.',
  numericWithPlusDashSpace: 'Only the plus sign, dash, space, and numeric characters are allowed.'

}

export const constructMessage = (message: string, replacement: string) =>
  message.replace('{item}', replacement);

export const constructMessageWithItem = (message: string, module: string, item: string) =>
  {
    const newMessage = message.replace('{item}', item);
    return newMessage.replace('{module}', module);
  };
